module.exports = __webpack_public_path__ + "static/img/agendas_loading_32.b647e25c.gif";